import React, { FC } from 'react';
import { useTheme } from 'styled-components';

import { Loader } from '../loader';

import { getLoadingColor } from './LoadingBasedOnProps.helpers';
import {
  $ButtonChildContainer,
  $LoaderContainer,
} from './LoadingBasedOnProps.styles';

interface LoadingBasedOnPropsInterface {
  disabled?: boolean;
  isLoading?: boolean;
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  success?: boolean;
  danger?: boolean;
  alert?: boolean;
}

const LoadingBasedOnProps: FC<
  React.PropsWithChildren<LoadingBasedOnPropsInterface>
> = (props) => {
  const theme = useTheme();

  const {
    disabled,
    isLoading,
    children,
    success,
    primary,
    secondary,
    tertiary,
    danger,
    alert,
  } = props;

  const shouldShowLoading = !disabled && isLoading;

  return (
    <>
      {shouldShowLoading && (
        <$LoaderContainer>
          <Loader
            size="16px"
            color={getLoadingColor(
              {
                disabled,
                isLoading,
                success,
                primary,
                secondary,
                tertiary,
                danger,
                alert,
              },
              theme,
            )}
            strokeWidth="10"
          />
        </$LoaderContainer>
      )}

      <$ButtonChildContainer $shouldShowLoading={shouldShowLoading}>
        {children}
      </$ButtonChildContainer>
    </>
  );
};

export default LoadingBasedOnProps;
